module Omni.ResortMap {
    ngModule.config(['$stateProvider', '$urlRouterProvider', '$locationProvider',
            function ($stateProvider, $urlRouterProvider, $locationProvider) {

                $stateProvider
                    .state('resort', {
                        templateUrl: "omni/assets/resortmap/views/resort.tpl.html",
                        controller: "ResortController"
                    })
                    .state('location', {
                        abstract: true,
                        params: {
                            "id": ""
                        },
                        resolve: {
                            "location": ["ResortProvider", "$stateParams", function (ResortProvider, $stateParams) {
                                return ResortProvider.getLocation($stateParams.id);
                            }]
                        },
                        templateUrl: "omni/assets/resortmap/views/location.tpl.html",
                        //controller: function() {},
                        controller: ["$rootScope", "$state", "$scope", "$stateParams", "location", function ($rootScope, $state, $scope, $stateParams, location) {
                            $scope.location = location;
                            $scope.baseState = (location.type !== 'undefined' && location.type == 'leisure') ? 'leisure' : 'floor';
                            if ($scope.$parent.isResort) {
                                $scope.showBackButton = true;
                                $scope.h1Class = "withBackButton";
                            } else {
                                $scope.showBackButton = false;
                                $scope.h1Class = "";
                            }
                            $scope.backButton = function () {
                                if ($scope.baseState == 'floor') {
                                    $rootScope["activeTab"] = 'meeting';
                                } else {
                                    $rootScope["activeTab"] = 'leisure';
                                }
                                $state.go('resort');
                            };
                            $scope.videoToggle = function () {
                                if ($state.current.name !== 'video') {
                                    $state.go('video');
                                } else {
                                    $state.go($scope.baseState);
                                }
                            };
                            $scope.showFloorRoomSelector = function () {
                                return $state.current.name === 'floor.detail';
                            };
                        }]
                    })
                    .state('video', {
                        parent: "location",
                        views: {
                            "main": {
                                templateUrl: "omni/assets/resortmap/views/video.tpl.html",
                                controller: ["$scope", "$sce", function ($scope, $sce) {
                                    $scope.video_url = null;
                                }]
                            }
                        }
                    })
                    .state('leisure', {
                        parent: "location",
                        views: {
                            "main": {
                                templateUrl: 'omni/assets/resortmap/views/slideshow.tpl.html',
                                controller: ["$scope", "$stateParams", function ($scope, $stateParams) {
                                    $scope.slides = $scope.location.gallery;
                                    $scope.showSlideNav = function () {
                                        return $scope.slides.length > 1;
                                    };
                                }]
                            }
                        }
                    })
                    .state('meeting', {
                        parent: "location",
                        views: {
                            "main": {
                                templateUrl: "omni/assets/resortmap/views/meeting.tpl.html"
                            }
                        }
                    })
                    .state('gallery', {
                        parent: "meeting",
                        views: {
                            "meetingMain": {
                                templateUrl: "omni/assets/resortmap/views/slideshow.tpl.html",
                                controller: ["$scope", function ($scope) {
                                    $scope.slides = $scope.location.gallery;
                                    $scope.showSlideNav = function () {
                                        return $scope.slides.length > 1;
                                    };
                                }]
                            }
                        }
                    })
                    .state('floor', {
                        parent: "meeting",
                        params: {
                            "id": ""
                        },
                        resolve: {
                            "location": ["ResortProvider", "$stateParams", function (ResortProvider, $stateParams) {
                                return ResortProvider.getLocation($stateParams.id);
                            }]
                        },
                        views: {
                            'meetingMain': {
                                templateUrl: "omni/assets/resortmap/views/floor.tpl.html",
                                controller: ["$scope", "$state", "$stateParams", "location", function ($scope, $state, $stateParams, location) {
                                    $scope.floors = location.floor;
                                    $scope.showBackButton = true;
                                    if (location.floor.length > 1) {
                                        $scope.showFloorSelector = true;
                                    } else {
                                        $scope.showFloorSelector = false;
                                    }
                                    $state.go('floor.detail', { id: $stateParams.id, floorId: 0 });
                                }]
                            }
                        }
                    })
                    .state("floor.detail", {
                        params: {
                            "id": "",
                            "floorId": ""
                        },
                        parent: "floor",
                        resolve: {
                            "location": ["ResortProvider", "$stateParams", function (ResortProvider, $stateParams) {
                                return ResortProvider.getLocation($stateParams.id);
                            }]
                        },
                        views: {
                            'floorContainer': {
                                templateUrl: "omni/assets/resortmap/views/floorContainer.tpl.html",
                                controller: ["$scope", "$state", "$stateParams", "$timeout", "location", function ($scope, $state, $stateParams, $timeout, location) {
                                    var id = $stateParams.floorId || 0;
                                    $scope.showBackButton = true;
                                    $scope.location = location;
                                    $scope.floor = location.floor[id];
                                    $scope.rooms = $scope.floor.room;
                                    $scope.showPopover = false;
                                    $scope.popover = null;
                                    $scope.floorIndex = $stateParams.floorId;
                                    $scope.closePopover = function () {
                                        $scope.$emit("closePopover");
                                    };
                                }]
                            }
                        }
                    })
                    .state('room', {
                        params: {
                            'id': "",
                            'floorId': "",
                            'roomId': ""
                        },
                        parent: 'floor.detail',
                        views: {
                            "@": {
                                templateUrl: "omni/assets/resortmap/views/room.tpl.html",
                                controller: "RoomController"
                            }
                        }
                    })
                    .state('room.video', {
                        parent: "room",
                        views: {
                            "roomMain": {
                                templateUrl: "omni/assets/resortmap/views/video.tpl.html",
                                controller: ["$scope", function ($scope) {
                                    $scope.showBackButton = true;
                                }]
                            }
                        }
                    });
                $locationProvider.html5Mode({
                    enabled: false,
                    requireBase: false
                    });

                $locationProvider.hashPrefix('');

            }])
        .run(['$rootScope', '$state', '$stateParams',
            function ($rootScope, $state, $stateParams) {
                $rootScope["$state"] = $state;
                $rootScope["$stateParams"] = $stateParams;
            }]);
}
